/** Brand-style marks for the “Integrates with” row. */

export function IconGoogle() {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" aria-hidden>
      <path
        fill="#FFC107"
        d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"
      />
      <path
        fill="#FF3D00"
        d="m6.306 14.691 6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"
      />
      <path
        fill="#4CAF50"
        d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238A11.91 11.91 0 0124 36c-5.19 0-9.546-3.135-11.283-7.591l-6.522 5.025C9.505 39.556 16.227 44 24 44z"
      />
      <path
        fill="#1976D2"
        d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 01-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"
      />
    </svg>
  );
}

export function IconGmail() {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" aria-hidden>
      <path
        fill="#EA4335"
        d="M8 14v20c0 1.1.9 2 2 2h8V22L24 28l6-6v14h8c1.1 0 2-.9 2-2V14H8z"
      />
      <path fill="#FBBC05" d="M8 14h32L24 26 8 14z" />
      <path fill="#C5221F" d="M8 14l16 12V14H8z" />
      <path fill="#34A853" d="M40 14H24v12l16-12z" />
    </svg>
  );
}

export function IconGoogleSheets() {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" aria-hidden>
      <rect x="8" y="8" width="32" height="32" rx="3" fill="#0F9D58" />
      <path fill="#fff" d="M15 15h18v3H15zm0 8h18v3H15zm0 8h11v3H15z" opacity="0.95" />
      <path fill="#B7E1CD" d="M28 31h11v3H28z" />
    </svg>
  );
}

export function IconGoogleCalendar() {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" aria-hidden>
      <rect x="8" y="10" width="32" height="32" rx="3" fill="#fff" stroke="#dadce0" strokeWidth="1.5" />
      <rect x="8" y="10" width="32" height="11" rx="3" fill="#1A73E8" />
      <path stroke="#fff" strokeWidth="2" strokeLinecap="round" d="M17 16h3m6 0h3m6 0h2" />
      <path fill="#1A73E8" d="M14 26h6v6h-6zm9 0h6v6h-6zm9 0h6v6h-6z" opacity="0.35" />
      <path fill="#1A73E8" d="M14 35h6v5h-6zm9 0h6v5h-6zm9 0h6v5h-6z" opacity="0.55" />
    </svg>
  );
}

export function IconApple() {
  return (
    <svg width="40" height="40" viewBox="0 0 24 24" aria-hidden>
      <path
        fill="#000"
        d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.81-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"
      />
    </svg>
  );
}

export function IconAndroid() {
  return (
    <svg width="40" height="40" viewBox="0 0 48 48" aria-hidden>
      <path
        fill="#A4C639"
        d="M12 36c0 2.2 1.8 4 4 4h1v7c0 1.1.9 2 2 2s2-.9 2-2v-7h4v7c0 1.1.9 2 2 2s2-.9 2-2v-7h1c2.2 0 4-1.8 4-4V20H12v16z"
      />
      <path
        fill="#A4C639"
        d="M38 22c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v8h4V22zm-32 0c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2v8h4V22z"
      />
      <path
        fill="#A4C639"
        d="M9 20 12 13c.2-.5.8-.7 1.3-.5l.9.5c.5.3.6.9.4 1.4l-2.5 4.1c-.3.6-1 .8-1.6.4l-.5-.3c-.6-.4-.8-1.1-.5-1.6zm30 0-3-7c-.2-.5-.8-.7-1.3-.5l-.9.5c-.5.3-.6.9-.4 1.4l2.5 4.1c.3.6 1 .8 1.6.4l.5-.3c.6-.4.8-1.1.5-1.6z"
      />
      <ellipse cx="24" cy="15" rx="11" ry="4.5" fill="#A4C639" />
    </svg>
  );
}
